<alliance-carousel *ngIf="state.carouselOptions as carouselOptions" [options]="carouselOptions" class="santa-mt-10">
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.connectVacancies">
    <p class="santa-typo-regular">{{ translations.content.combineActiveVacancies | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.fillFields">
    <p class="santa-typo-regular">{{ translations.content.fillCandidateInfo | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.addFromDataBase">
    <p class="santa-typo-regular">
      <span>{{ translations.content.dataBase.allApplies | translate }}</span>
      <a class="santa-text-red-500 santa-underline hover:santa-text-red-600" [routerLink]="['/candidates']">{{ translations.content.dataBase.helper | translate }}</a>
      <span>{{ translations.content.dataBase.use | translate }}</span>
    </p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.useBrowserExtension">
    <p class="santa-typo-regular">
      <span>{{ translations.content.plugin.install | translate }}</span>
      <a [href]="ATS_EXTENSION_URL" target="_blank" class="santa-text-red-500 santa-underline hover:santa-text-red-600">{{ translations.content.plugin.extension | translate }}</a>
      <span>{{ translations.content.plugin.toAddCandidates | translate }}</span>
    </p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.uploadFromTable">
    <p class="santa-typo-regular">{{ translations.content.uploadFileWithCandidates | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.addFromRobota">
    <p class="santa-typo-regular">{{ translations.content.addFromRobota | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.createProjectFromVacancy">
    <p class="santa-typo-regular">{{ translations.content.createProjectFromVacancy | translate }}</p>
  </lib-slide-template>
</alliance-carousel>
